import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-delete-cover-page-modal",
  templateUrl: "./delete-cover-page-modal.component.html",
  styleUrls: ["./delete-cover-page-modal.component.scss"],
})
export class DeleteCoverPageModalComponent {
  @Input() coverPageTitle = "Attention!";

  @Output() close = new EventEmitter();
  @Output() submit = new EventEmitter();

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.DeleteCoverPage;
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }

  onSubmit() {
    this._modalService.closeModal();
    this.submit.emit();
  }
}
